// Primary site navigation — kept flat and short on purpose so it's
// immediately clear what PROVIRTUES does. Secondary pages (Dedicated Teams,
// Managed Project Delivery, Industries, Case Studies, Insights) are still
// live routes, reachable from the Services page, Home page, and footer.
const navigationData = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Staff Augmentation', path: '/staff-augmentation' },
  { label: 'Government', path: '/government-subcontracting' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export default navigationData;
